export class Parametro {
    static readonly DETALLES_PRIVADOS: string = 'DETALLES_PRIVADOS';
    static readonly SII_ACTIVADO: string = 'SII_ACTIVADO';
    static readonly CONCEPTO_ACTIVADO = 'CONCEPTO_ACTIVADO';
    static readonly TIPO_AGENDAMIENTO: string = 'TIPO_AGENDAMIENTO';
    static readonly DURACION_REUNION: string = 'DURACION_REUNION';
    static readonly DESCARGA_AUTOMATICA: string = 'DESCARGA_AUTOMATICA';
    static readonly FORMATO_PRECIO_REVISION: string = 'FORMATO_PRECIO_REVISION';
    static readonly FORMATO_TAMANO_REVISION: string = 'FORMATO_TAMANO_REVISION';
    static readonly IVA: string = 'IVA';
    static readonly UPDATE_PRECIO_COMPRA_EXACTO: string = 'UPDATE_PRECIO_COMPRA_EXACTO';
    static readonly PERMITIR_PRECIOS_PDF_CLIENTE_APP: string = 'PERMITIR_PRECIOS_PDF_CLIENTE_APP';
    static readonly SERVICIOS_EN_VENTA: string = 'SERVICIOS_EN_VENTA';
    static readonly OPERADOR_EDITA_VENTAS: string = 'OPERADOR_EDITA_VENTAS';
    static readonly OPERADOR_PUEDE_VER_CAJA: string = 'OPERADOR_PUEDE_VER_CAJA';
    static readonly OPERADOR_PUEDE_VER_CATALOGO: string = 'OPERADOR_PUEDE_VER_CATALOGO';
    static readonly ASIGNA_FOLIO_VACIO: string = 'ASIGNA_FOLIO_VACIO';
    static readonly RECORDATORIO_DEUDAS_CLIENTE: string = 'RECORDATORIO_DEUDAS_CLIENTE';
    static readonly METODO_PAGO_POR_DEFECTO_OT: string = 'METODO_PAGO_POR_DEFECTO_OT';
    static readonly RESUMEN_SEMANAL_ACTIVADO: string = 'RESUMEN_SEMANAL_ACTIVADO';
    static readonly CAJA_OBLIGATORIA: string = 'CAJA_OBLIGATORIA';
    static readonly OT_COMPLETADA_CAJA: string = 'OT_COMPLETADA_CAJA';
    static readonly OT_COMPLETADA_REPORTE: string = 'OT_COMPLETADA_REPORTE';

    static readonly SEPARAR_PRODUCTO_SERVICIO_DOC: string = 'SEPARAR_PRODUCTO_SERVICIO_DOC';
    static readonly MOSTRAR_SKU_DOC: string = 'MOSTRAR_SKU_DOC';
    static readonly CATALOGO_ACTIVADO: string = 'CATALOGO_ACTIVADO';
    static readonly MOSTRAR_OT_EN_INDEX_COTIZACIONES: string = 'MOSTRAR_OT_EN_INDEX_COTIZACIONES';
    static readonly TIPO_PRECIO: string = 'TIPO_PRECIO';

    static readonly KILOMETRAJE_REVISION_OPCIONAL: string = 'KILOMETRAJE_REVISION_OPCIONAL';
    static readonly PRECIO_PRODUCTO_OPCIONAL: string = 'PRECIO_PRODUCTO_OPCIONAL';
    static readonly RECIBIR_COTIZACIONES: string = 'RECIBIR_COTIZACIONES';
    static readonly MAXIMO_ARCHIVOS_OT: string = 'MAXIMO_ARCHIVOS_OT';
    static readonly OPERADOR_CREA_PRODUCTOS_EN_REVISION: string = 'OPERADOR_CREA_PRODUCTOS_EN_REVISION';

    static readonly COMISION_TARJETA_DEBITO: string = 'COMISION_TARJETA_DEBITO';
    static readonly COMISION_TARJETA_CREDITO: string = 'COMISION_TARJETA_CREDITO';

    static readonly MOSTRAR_OBSERVACIONES_DOCUMENTO: string = 'MOSTRAR_OBSERVACIONES_DOCUMENTO';
    static readonly MOSTRAR_DETALLES_DOCUMENTO: string = 'MOSTRAR_DETALLES_DOCUMENTO';
    static readonly MOSTRAR_OBSERVACIONES_DTE: string = 'MOSTRAR_OBSERVACIONES_DTE';
    static readonly MOSTRAR_DETALLES_DTE: string = 'MOSTRAR_DETALLES_DTE';
    static readonly SII_INCLUIR_DESCRIPCION_PRODUCTO_DTE: string = 'SII_INCLUIR_DESCRIPCION_PRODUCTO_DTE';
    static readonly MOSTRAR_SKU_DTE: string = 'MOSTRAR_SKU_DTE';
    static readonly MOSTRAR_MARCA_PRODUCTO_DOCUMENTO: string = 'MOSTRAR_MARCA_PRODUCTO_DOCUMENTO';
    static readonly MOSTRAR_MARCA_PRODUCTO_DTE: string = 'MOSTRAR_MARCA_PRODUCTO_DTE';
    static readonly MOSTRAR_PATENTE_VEHICULO_DTE: string = 'MOSTRAR_PATENTE_VEHICULO_DTE';
    static readonly INCLUIR_INFORMACION_EXTRA_DTE: string = 'INCLUIR_INFORMACION_EXTRA_DTE';

    static readonly TIPO_AGENDAMIENTO_DEFAULT: string = '2';
    static readonly DURACION_REUNION_DEFAULT: string = '30';
    static readonly FORMATO_TAMANO_REVISION_DEFAULT: string = '1';
    static readonly FORMATO_PRECIO_REVISION_DEFAULT: string = '1';
    static readonly DESCARGA_AUTOMATICA_DEFAULT: string = '1';
    static readonly PERMITIR_PRECIOS_PDF_CLIENTE_APP_DEFAULT: string = '1';
    static readonly OPERADOR_EDITA_VENTAS_DEFAULT: boolean = true;
    static readonly OPERADOR_PUEDE_VER_CAJA_DEFAULT: boolean = false;
    static readonly OPERADOR_PUEDE_VER_CATALOGO_DEFAULT: boolean = false;
    static readonly ASIGNA_FOLIO_VACIO_DEFAULT: boolean = false;
    static readonly RECORDATORIO_DEUDAS_CLIENTE_DEFAULT: string = '7';
    static readonly METODO_PAGO_POR_DEFECTO_OT_DEFAULT: string = '1';
    static readonly KILOMETRAJE_REVISION_OPCIONAL_DEFAULT: string = '0';
    static readonly PRECIO_PRODUCTO_OPCIONAL_DEFAULT: string = '0';
    static readonly MAXIMO_ARCHIVOS_OT_DEFAULT: string = '5';
    static readonly OPERADOR_CREA_PRODUCTOS_EN_REVISION_DEFAULT: string = '0';
    static readonly CATALOGO_ACTIVADO_DEFAULT: string = '1';
    static readonly MOSTRAR_OT_EN_INDEX_COTIZACIONES_DEFAULT: string = '1';
    static readonly TIPO_PRECIO_DEFAULT: string = '';
    static readonly MOSTRAR_OBSERVACIONES_DOCUMENTO_DEFAULT: string = '1';
    static readonly MOSTRAR_DETALLES_DOCUMENTO_DEFAULT: string = '1';
    static readonly MOSTRAR_OBSERVACIONES_DTE_DEFAULT: string = '0';
    static readonly MOSTRAR_DETALLES_DTE_DEFAULT: string = '0';
    static readonly MOSTRAR_SKU_DTE_DEFAULT: string = '0';
    static readonly MOSTRAR_MARCA_PRODUCTO_DOCUMENTO_DEFAULT: string = '0';
    static readonly MOSTRAR_MARCA_PRODUCTO_DTE_DEFAULT: string = '0';
    static readonly MOSTRAR_PATENTE_VEHICULO_DTE_DEFAULT: string = '0';
    static readonly INCLUIR_INFORMACION_EXTRA_DTE_DEFAULT: string = '0';
}